module.exports = __webpack_public_path__ + "img/accordion_icon.341532d1.png";